(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quote-form-native"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.name?.startsWith('rp-quote-response-')) return;
    const attempts = new WeakMap();
    let sequence = 0;
    let pending = null;
    const formsFor = (form) => [...new Set([form, ...document.querySelectorAll('[data-rp-native-quote]')])];
    const valuesFor = (form) => [...form.querySelectorAll('[data-rp-quote-panel] input, [data-rp-quote-panel] textarea')].map((field) => [field.name, field.value]);
    const restoreValues = (form, values) => {
      form.querySelectorAll('[data-rp-quote-panel] input, [data-rp-quote-panel] textarea').forEach((field) => {
        const value = values.find(([name]) => name === field.name);
        if (value) field.value = value[1];
      });
    };
    const configFor = (form) => form.querySelector('[data-rp-native-config]').dataset;
    const statusFor = (form) => form.querySelector('[data-rp-quote-status]');
    const release = (form, message = '') => {
      form.dataset.submitting = 'false';
      delete form.dataset.quoteResponseReason;
      form.removeAttribute('aria-busy');
      const button = form.querySelector('[data-rp-native-submit]');
      button.disabled = false;
      button.textContent = form.dataset.submitLabel || button.textContent;
      statusFor(form).textContent = message;
    };
    const finish = (form, animate = true) => {
      if (form.dataset.submitted === 'true') return;
      form.dataset.submitted = 'true';
      form.dataset.submitting = 'false';
      delete form.dataset.quoteResponseReason;
      form.removeAttribute('aria-busy');
      const panel = form.querySelector('[data-rp-quote-panel]');
      const status = statusFor(form);
      panel.inert = true;
      panel.setAttribute('aria-hidden', 'true');
      form.querySelectorAll('input, textarea, button').forEach((field) => { field.disabled = true; });
      const confirm = () => {
        form.classList.add('is-success');
        status.textContent = configFor(form).success;
        if (form.isConnected && form.getClientRects().length) status.focus({ preventScroll: true });
      };
      if (animate) {
        form.classList.add('rp-native-animating');
        status.textContent = '';
        requestAnimationFrame(() => requestAnimationFrame(confirm));
      } else {
        confirm();
      }
    };
    const returnedForms = (doc) => {
      const results = [...doc.querySelectorAll('[data-rp-native-quote]')];
      const visit = (root) => root.querySelectorAll('template').forEach((template) => {
        results.push(...template.content.querySelectorAll('[data-rp-native-quote]'));
        visit(template.content);
      });
      visit(doc);
      return [...new Set(results)].filter((result) => result.matches('form') && result.querySelector('[name="form_type"][value="contact"]'));
    };
    const createAttempt = (form) => {
      const config = configFor(form);
      const request = pending;
      const resume = form.querySelector('[data-rp-native-resume]');
      const dialog = document.createElement('dialog');
      dialog.className = 'rp-quote-verification';
      const header = document.createElement('div');
      header.className = 'rp-quote-verification__header';
      const heading = document.createElement('p');
      heading.id = `rp-quote-verification-${++sequence}`;
      heading.textContent = config.verification;
      dialog.setAttribute('aria-labelledby', heading.id);
      const close = document.createElement('button');
      close.type = 'button';
      close.textContent = config.close;
      header.append(heading, close);
      const frame = document.createElement('iframe');
      frame.name = `rp-quote-response-${Date.now()}-${sequence}`;
      frame.title = config.verification;
      dialog.append(header, frame);
      let timer;
      let active = true;
      let awaitingResponse = false;
      let serialized = false;
      let verificationTokenSeen = false;
      let restoreDrawer = () => {};
      const allowVerification = () => {
        const drawer = form.closest('dialog[data-dialog]');
        if (!drawer?.closest('modal-popup') || !drawer.matches(':modal')) return;
        const onClose = () => {
          if (drawer.open) return;
          drawer.classList.remove('rp-quote-verifying');
          drawer.removeEventListener('close', onClose);
        };
        restoreDrawer = () => {
          if (!drawer.classList.contains('rp-quote-verifying') || drawer.hasAttribute('closing')) return;
          drawer.removeEventListener('close', onClose);
          drawer.classList.remove('rp-quote-verifying');
          if (drawer.isConnected && drawer.open && !drawer.matches(':modal')) {
            drawer.close();
            drawer.showModal();
          }
        };
        drawer.close();
        drawer.classList.add('rp-quote-verifying');
        drawer.addEventListener('close', onClose);
        drawer.show();
      };
      const onFormData = (event) => {
        if (!active || !awaitingResponse) return;
        serialized = true;
        verificationTokenSeen ||= Boolean(event.formData.get('h-captcha-response'));
        form.dataset.quoteSubmissionStage = verificationTokenSeen ? 'serialized-with-verification' : 'serialized';
        if (verificationTokenSeen) restoreDrawer();
      };
      form.addEventListener('formdata', onFormData);
      const originalTarget = form.getAttribute('target');
      const restore = () => {
        if (originalTarget === null) form.removeAttribute('target');
        else form.setAttribute('target', originalTarget);
      };
      const dispose = () => {
        active = false;
        clearTimeout(timer);
        frame.removeEventListener('load', onLoad);
        form.removeEventListener('formdata', onFormData);
        formsFor(form).forEach((current) => { current.querySelector('[data-rp-native-resume]').hidden = true; });
        if (dialog.open) dialog.close();
        dialog.remove();
        restoreDrawer();
        restore();
        attempts.delete(form);
      };
      const unknown = (reason) => {
        clearTimeout(timer);
        request.state = 'uncertain';
        const code = reason === 'response-timeout'
          ? (verificationTokenSeen ? 'QF-02' : serialized ? 'QF-03' : 'QF-01')
          : ({ 'different-origin': 'QF-04', 'missing-result': 'QF-05', 'missing-form': 'QF-06', 'unreadable-response': 'QF-07' }[reason] || 'QF-08');
        request.message = `${config.uncertain} (${code})`;
        formsFor(form).forEach((current) => {
          current.removeAttribute('aria-busy');
          current.dataset.quoteResponseReason = reason;
          current.dataset.quoteDiagnostic = code;
          statusFor(current).textContent = request.message;
          current.querySelector('[data-rp-native-submit]').disabled = true;
        });
        form.querySelector('[data-rp-native-submit]').textContent = form.dataset.submitLabel;
      };
      const show = () => {
        if (!active) return;
        clearTimeout(timer);
        request.state = 'verification';
        request.message = config.verification;
        formsFor(form).forEach((current) => {
          current.removeAttribute('aria-busy');
          statusFor(current).textContent = config.verification;
          current.querySelector('[data-rp-native-resume]').hidden = false;
        });
        if (!dialog.open) dialog.showModal();
        frame.focus();
      };
      const hide = () => {
        dialog.close();
        request.message = config.verificationPending;
        formsFor(form).forEach((current) => {
          current.querySelector('[data-rp-native-resume]').hidden = false;
          statusFor(current).textContent = config.verificationPending;
        });
        if (resume.isConnected) resume.focus({ preventScroll: true });
      };
      close.addEventListener('click', hide);
      dialog.addEventListener('cancel', (event) => { event.preventDefault(); hide(); });
      const onLoad = () => {
        if (!active || !awaitingResponse) return;
        try {
          const href = frame.contentWindow.location.href;
          if (href === 'about:blank') return;
          const url = new URL(href);
          if (url.origin !== window.location.origin) { unknown('different-origin'); return; }
          if (/\/challenge\/?$/.test(url.pathname)) { show(); return; }
          const results = returnedForms(frame.contentDocument);
          const errors = results.map((result) => result.querySelector('[data-rp-native-errors]')?.textContent.trim()).filter(Boolean).join(' ');
          if (errors) {
            dispose();
            pending = null;
            formsFor(form).forEach((current) => {
              if (current !== form && current.id === form.id) restoreValues(current, request.values);
              release(current, errors);
            });
          } else if (results.some((result) => result.querySelector('[data-rp-native-complete]'))) {
            request.state = 'success';
            dispose();
            formsFor(form).forEach((current) => finish(current));
          } else {
            unknown(results.length ? 'missing-result' : 'missing-form');
          }
        } catch {
          unknown('unreadable-response');
        }
      };
      frame.addEventListener('load', onLoad);
      document.body.append(dialog);
      const submit = (protectedForm) => {
        form.setAttribute('target', frame.name);
        awaitingResponse = true;
        form.dataset.quoteSubmissionStage = protectedForm ? 'awaiting-verification' : 'awaiting-serialization';
        timer = setTimeout(() => unknown('response-timeout'), 45000);
        allowVerification();
        if (protectedForm) form.submit();
        else form.requestSubmit();
      };
      return { submit, dispose, show };
    };
    const init = (root) => {
      root.querySelectorAll('[data-rp-native-quote]').forEach((form) => {
        if (form.querySelector('[data-rp-native-complete]') || pending?.state === 'success') {
          finish(form, form.getClientRects().length > 0);
        } else if (pending) {
          statusFor(form).textContent = pending.message;
          form.querySelector('[data-rp-native-submit]').disabled = true;
          form.querySelector('[data-rp-native-resume]').hidden = pending.state !== 'verification';
        }
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('click', async (event) => {
      const resume = event.target.closest('[data-rp-native-resume]');
      if (resume) { event.preventDefault(); pending?.attempt?.show(); return; }
      const button = event.target.closest('[data-rp-native-submit]');
      if (!button) return;
      event.preventDefault();
      const form = button.closest('[data-rp-native-quote]');
      if (!form || form.dataset.submitting === 'true' || form.dataset.submitted === 'true') return;
      if (form.querySelector('[data-rp-native-complete]')) { finish(form); return; }
      if (pending) {
        if (pending.state === 'success') finish(form);
        else {
          statusFor(form).textContent = pending.message;
          form.querySelector('[data-rp-native-submit]').disabled = true;
          form.querySelector('[data-rp-native-resume]').hidden = pending.state !== 'verification';
        }
        return;
      }
      const config = configFor(form);
      const address = form.querySelector('[data-rp-native-address]');
      const customerField = form.querySelector('[data-rp-native-name]');
      customerField.value = customerField.value.trim();
      address.value = address.value.trim();
      const phoneField = form.querySelector('[name="contact[phone]"]');
      phoneField.value = phoneField.value.trim();
      address.setCustomValidity('');
      if (!form.reportValidity()) return;
      const status = statusFor(form);
      const captcha = window.Shopify?.captcha;
      pending = { state: 'sending', message: config.sending, values: valuesFor(form), attempt: null };
      form.dataset.submitLabel = button.textContent;
      form.dataset.submitting = 'true';
      form.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.textContent = config.sending;
      status.textContent = '';
      let attempt;
      let posted = false;
      try {
        const response = await fetch(config.cartUrl, {
          headers: { Accept: 'application/json' }, cache: 'no-store', signal: AbortSignal.timeout(15000)
        });
        if (!response.ok) throw new Error('cart');
        const cart = await response.json();
        if (!cart.items?.length) { status.textContent = config.empty; return; }
        const lines = [config.items];
        cart.items.forEach((item, index) => {
          if (index) lines.push('', '────────────────────────');
          lines.push('', `${index + 1}. ${item.product_title || item.title}`);
          if (item.variant_title && item.variant_title !== 'Default Title') lines.push(item.variant_title);
          lines.push(`${config.partNumber}: ${item.sku || ''}`, `${config.quantity}: ${item.quantity}`);
          if (item.url) lines.push(`${config.link}: ${new URL(item.url, window.location.origin).href}`);
          Object.entries(item.properties || {}).forEach(([name, value]) => {
            if (!name.startsWith('_') && value !== null && value !== '') lines.push(`${name}: ${value}`);
          });
        });
        if (cart.note) lines.push('', `${config.cartNote}: ${cart.note}`);
        form.querySelector('[data-rp-native-items]').value = lines.join('\n');
        if (typeof captcha?.protect === 'function') {
          await new Promise((resolve, reject) => {
            const timer = setTimeout(() => reject(new Error('captcha')), 15000);
            captcha.protect(form, () => { clearTimeout(timer); resolve(); });
          });
        }
        address.setCustomValidity('');
        customerField.value = customerField.value.trim();
      address.value = address.value.trim();
      const phoneField = form.querySelector('[name="contact[phone]"]');
      phoneField.value = phoneField.value.trim();
        if (!form.isConnected || !form.reportValidity()) return;
        pending.values = valuesFor(form);
        attempt = createAttempt(form);
        attempts.set(form, attempt);
        pending.attempt = attempt;
        attempt.submit(typeof captcha?.protect === 'function');
        posted = true;
      } catch (error) {
        attempt?.dispose();
        status.textContent = error.message === 'captcha' ? config.unavailable : config.error;
      } finally {
        if (!posted) {
          pending = null;
          formsFor(form).forEach((current) => release(current, status.textContent));
        }
      }
    });
    document.addEventListener('input', (event) => {
      if (event.target.matches('[data-rp-native-address]')) event.target.setCustomValidity('');
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || event.isComposing || event.target.tagName !== 'INPUT') return;
      const form = event.target.closest('[data-rp-native-quote]');
      if (!form) return;
      event.preventDefault();
      form.querySelector('[data-rp-native-submit]')?.click();
    });
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      document.querySelectorAll('[data-rp-native-quote][data-submitting="true"]').forEach((form) => {
        if (!pending && !attempts.has(form)) release(form);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quote-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-rp-quote-submit]');
    if (!button) return;
    event.preventDefault();
    const wrapper = button.closest('[data-rp-quote-form]');
    if (!wrapper || wrapper.dataset.submitting === 'true' || wrapper.dataset.submitted === 'true') return;
    const fields = Array.from(wrapper.querySelectorAll('input, textarea'));
    fields.filter(field => ['full_name', 'email', 'phone', 'delivery_address'].includes(field.name)).forEach(field => {field.value = field.value.trim();});
    for (const field of fields) {
      if (!field.reportValidity()) return;
    }
    const status = wrapper.querySelector('[data-rp-quote-status]');
    const app = window.QTEEDY;
    if (!app || typeof app.app_url !== 'function' || typeof app.current_shop !== 'function') {
      status.textContent = wrapper.dataset.unavailable;
      return;
    }
    const values = Object.fromEntries(fields.map((field) => [field.name, field.value.trim()]));
    if (!window.RPQuoteList) { status.textContent = wrapper.dataset.unavailable; return; }
    await window.RPQuoteList.submitOnce(async () => {
    const originalLabel = button.textContent;
    wrapper.dataset.submitting = 'true';
    wrapper.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = wrapper.dataset.sending;
    status.textContent = '';
    try {
      const cart = await window.RPQuoteList.snapshot();
      if (!cart.items?.length) {
        status.textContent = wrapper.dataset.empty;
        return;
      }
      const nameParts = values.full_name.split(/\s+/);
      const customer = { first_name: nameParts.shift(), last_name: nameParts.join(' '), email: values.email };
      const deliveryLocation = values.delivery_address;
      const requirements = [values.machine_details, values.machine_reference, values.quote_details].filter(Boolean).join('\n\n');
      if (values.phone) customer.phone = values.phone;
      if (values.company) customer.company = values.company;
      const quoteCart = {
        ...cart,
        attributes: {
          ...cart.attributes,
          rp_quote_company: values.company,
          rp_quote_delivery_address: deliveryLocation,
          rp_quote_requirements: requirements
        }
      };
      const payload = {
        customer,
        email: values.email,
        cart: quoteCart,
        shop: app.current_shop(),
        shipping_rate: null,
        shipping_name: null,
        note_attributes: { company: values.company, quote_details: [deliveryLocation ? `${wrapper.dataset.addressLabel}: ${deliveryLocation}` : '', requirements].filter(Boolean).join('\n\n') }
      };
      const response = await fetch(`${app.app_url()}/quotes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!response.ok) throw new Error('Quote service unavailable');
      const result = await response.json();
      if (result.ok !== true) throw new Error('Quote rejected');
      wrapper.dataset.submitted = 'true';
      try { await window.RPQuoteList.complete(cart.items); }
      catch { window.RPQuoteList.error(wrapper.dataset.cleanupError); }
      wrapper.classList.add('is-success');
      status.textContent = wrapper.dataset.success;
      wrapper.removeAttribute('aria-busy');
      status.focus({ preventScroll: true });
      const panel = wrapper.querySelector('[data-rp-quote-panel]');
      panel.inert = true;
      panel.setAttribute('aria-hidden', 'true');
      fields.forEach((field) => { field.disabled = true; });
      document.querySelector('[data-rp-quote-new]').hidden = false;
      try {
        window.RPEnquiryAnalytics?.track('rd_submitted_quote_form', {quote_item_count:cart.item_count, enquiry_route:cart.attributes.rp_enquiry_mode || 'quote_list'});
      } catch {}
    } catch {
      status.textContent = wrapper.dataset.error;
    } finally {
      wrapper.dataset.submitting = 'false';
      wrapper.removeAttribute('aria-busy');
      button.disabled = wrapper.dataset.submitted === 'true';
      button.textContent = originalLabel;
    }
    });
  });
  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-rp-quote-address]')) event.target.setCustomValidity('');
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || event.isComposing || event.target.tagName !== 'INPUT') return;
    const wrapper = event.target.closest('[data-rp-quote-form]');
    if (!wrapper) return;
    event.preventDefault();
    wrapper.querySelector('[data-rp-quote-submit]')?.click();
  });
  } catch(e) { console.error(e); }
})();

})();
